// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cfd2f78f","667":"103f5bfc"}[chunkId] + ".chunk.js";
};